import type { Metadata } from 'next';

const CV_METATAG = {
  title: 'ISUZU TRUCKS Thailand Official',
  description:
    'เจ้าแห่งรถบรรทุก อีซูซุ คิงออฟทรัคส์ - ISUZU TRUCKS Thailand Official',
  url: 'https://truck.isuzu-tis.com/',
  image: 'https://assets.isuzu-tis.com/og_truck_isuzu_official_ec72de4352.jpg',
} as const;

export const CV_METADATA: Metadata = {
  title: CV_METATAG.title,
  description: CV_METATAG.description,
  openGraph: {
    title: CV_METATAG.title,
    description: CV_METATAG.description,
    url: CV_METATAG.url,
    images: [
      {
        url: CV_METATAG.image,
        width: 1200,
        height: 630,
      },
    ],
  },
  alternates: {
    canonical: CV_METATAG.url,
  },
};
